
import { createClient } from '@supabase/supabase-js';

const PROVIDED_URL = 'https://njyxdgwonewewbvsktsj.supabase.co';
const PROVIDED_ANON_KEY = 'sb_publishable_iuLiMcGA7dyPYmP7UaVD3A_D53hwWJa';

export const supabase = createClient(PROVIDED_URL, PROVIDED_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
